module.exports = __webpack_public_path__ + "static/media/stripe.e4590c1a.svg";